import { render, staticRenderFns } from "./TicketReplace.vue?vue&type=template&id=4c5446af&"
import script from "./TicketReplace.vue?vue&type=script&lang=js&"
export * from "./TicketReplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports